export default "__VITE_ASSET__D5ewF9YD__"